import { VirtualInboxDashboard } from "@/components/virtual-inbox/virtual-inbox-dashboard";
import { orpc } from "@/lib/orpc";
import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useSearchFilters } from "@/hooks/use-search-filters";

export const Route = createFileRoute("/_app/projects/$projectSlug/_layout/virtual-inbox")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  const { filters, setFilters } = useSearchFilters(Route.id);
  const { data: project } = useSuspenseQuery(
    orpc.projects.getBySlug.queryOptions({ input: params }),
  );

  return (
    <VirtualInboxDashboard
      project={project}
      environment={filters.env}
      onEnvironmentChange={(env) => setFilters({ env })}
    />
  );
}
